import React from 'react';
import { Alert } from 'react-bootstrap';

const AlertMessage = ({ variant = 'danger', message, onClose, className = '' }) => {
  if (!message) return null;

  return (
    <Alert variant={variant} dismissible={!!onClose} onClose={onClose} className={className}>
      {message}
    </Alert>
  );
};

export default AlertMessage;

